import React from 'react';
import classNames from 'classnames/bind';
import styles from './Dialogue.module.scss';

const cx = classNames.bind(styles);

export type DialogueProps = {
  children: React.ReactNode;
  speaker: string;
};

function Dialogue({ children, speaker }: DialogueProps): JSX.Element {
  return (
    <div className={cx('dialogue_wrap')}>
      <strong className={cx('dialogue_name')} data-testid="speaker">
        {speaker}
      </strong>
      {children}
    </div>
  );
}

export default Dialogue;
